// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/certificates/:certificateId`
  | `/exam-event-examinees/:examEventExamineeId`
  | `/exam-event-examinees/:examEventExamineeId/social-media`
  | `/exam-event-examinees/:examEventExamineeId/unofficial`

export type Params = {
  '/certificates/:certificateId': { certificateId: string }
  '/exam-event-examinees/:examEventExamineeId': { examEventExamineeId: string }
  '/exam-event-examinees/:examEventExamineeId/social-media': { examEventExamineeId: string }
  '/exam-event-examinees/:examEventExamineeId/unofficial': { examEventExamineeId: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
